import { Injectable } from "@angular/core";
// @ts-ignore - mustache types are incorrect about mustache not having a default export
import Mustache from "mustache";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

// Strong type for known template names sourced from livekit-agent wila_oasis_vnext templates
export type TemplateName =
  | "question_agent_prompt"
  | "question_agent_schema_message";

/**
 * TemplateService renders Mustache templates given a template string and context object.
 */
@Injectable({ providedIn: "root" })
export class TemplateService {
  constructor(private http: HttpClient) {}

  /**
   * Fetch a Mustache template by name and render it with the provided context.
   * Returns a Promise resolving to the rendered template string.
   */
  public async renderTemplate(
    name: TemplateName,
    context: Record<string, any>,
  ): Promise<string> {
    if (!name) throw new Error("Template name required");
    const url = `/assets/templates/${name}.mustache`;
    try {
      const template = await firstValueFrom(
        this.http.get(url, { responseType: "text" }),
      );
      return this.render(template, context);
    } catch (err: any) {
      throw new Error(
        `Failed to load or render template '${name}': ${err?.message || err}`,
      );
    }
  }

  /**
   * Render a Mustache template string with a context object.
   */
  private render(template: string, context: Record<string, any>): string {
    try {
      return Mustache.render(template, context || {});
    } catch (e) {
      console.error("TemplateService render error", e);
      throw e;
    }
  }
}
